module.exports = __webpack_public_path__ + "static/media/featureConnected_hero.01d75c90.jpg";